// extracted by mini-css-extract-plugin
module.exports = {"pinTopItem":"styles_pinTopItem__7VzNj","pinBottomItem":"styles_pinBottomItem__c9b0h"};